// AddGroup.js
import PageContainer from "../PageContainer";
import { GroupForm } from "./GroupForm";
import { useData } from "../../../contexts/DataContext/DataContextt";
import { saveGroup } from "../../../services/groupService";
import { useState } from "react";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";

const AddGroup = () => {
  const { loading } = useData();
  const { showNotification } = usePreload();
  const [saving, setSaving] = useState(false);

  const onSave = async (updatedRow) => {
    if (!updatedRow.groupCode) {
      showNotification("group code is required", "error");
      return false;
    }

    try {
      setSaving(true);
      let newGroup = { ...updatedRow };
      // apiRequest hands back the raw Response on a non-2xx instead of throwing
      const response = await saveGroup(newGroup);
      if (response instanceof Response && !response.ok) {
        throw new Error(`Add group failed with status ${response.status}`);
      }
      showNotification(`new group was added!`, "success");
      return true;
    } catch (e) {
      console.error(e);
      showNotification(`something went wrong when adding ${updatedRow?.groupCode} group.`, "error");
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Group"
      breadcrumbs={[{ title: "ETIM Group", path: "/groups" }, { title: "New" }]}
    >
      <GroupForm
        onSave={onSave}
        props={{
          row: {},
          loading: loading,
          uploading: saving,
          showCancel: false,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddGroup;
